import { SERVER } from '@/constants/servers';
import fetch from '@/lib/fetch';

/**
 * @typedef IStudentDMRes
 * @property {string} url
 */

/**
 * 获取当前学生对应的家长的来源对应的 DM 单二维码图片链接
 * @return {Promise.<IStudentDMRes>}
 */
export function getStudentDm() {
  return fetch(`${SERVER}/students/dm`, {}, {
    method: 'post',
  });
}
